import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@els/els-react--dropdown';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { sortingOptionsTypeMap } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogConstants';

function SortingDropdown({ sortingType, onOccurrence, onByValue, onClickClearSelected, className }) {
  const options = [
    {
      id: occurrence,
      label: sortingOptionsTypeMap[occurrence],
    },
    {
      id: byValue,
      label: sortingOptionsTypeMap[byValue],
    }
  ];
  const selectedOption = options.find((option) => option.id === sortingType);
  const onChange = (option) => {
    switch (option.id) {
      case occurrence:
        onOccurrence();
        break;
      case byValue:
        onByValue();
        break;
      default:
        return;
    }

    onClickClearSelected();
  };

  return (
    <Dropdown
      label={`Sort by ${sortingOptionsTypeMap[sortingType]}`}
      options={options}
      selected={selectedOption}
      onChange={onChange}
      showSelectedAsLabel={false}
      id="filter-dialog-sorting-dropdown"
      className={className}
      flyoutProps={{
        placement: 'bottom-end',
        pointer: true,
        pointerType: 'primary',
      }}
    />
  );
}

SortingDropdown.propTypes = {
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  onOccurrence: PropTypes.func.isRequired,
  onByValue: PropTypes.func.isRequired,
  onClickClearSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SortingDropdown;
